import { Api, HttpClient } from '@/generated';
import axios from './axios';

const client = new HttpClient();
client.instance = axios;

const api = new Api(client);

export default api;
